const onlyKeyFocuses = () => {
  const element = document.documentElement

  let mouseDown = false
  
  element.addEventListener('mousedown', () => {
    mouseDown = true
    element.classList.remove('focus-on')
  })
  element.addEventListener('mouseup', () => {
    mouseDown = false
  })

  element.addEventListener('keydown', event => {
    const currentKey = event.code
    if (currentKey === 'Tab') {
      if (!mouseDown) {
        element.classList.add('focus-on')
      } else {
        element.classList.remove('focus-on')
      }
    }
  })
}
onlyKeyFocuses()

// scss:
// html {
//   &.focus-on {
//     a,
//     input,
//     select,
//     textarea,
//     button {
//       &:focus {
//         outline: none;
//         box-shadow: 0 0 2px 2px #d72313; 
//       }
//     }
//   }
// }